import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Stack, ThemeProvider } from '@mui/material';
import React from 'react';
import { generateTheme } from '../themes';
import { RPMButton } from './subComponents/RPMButton';
import { RPMImage } from './subComponents/RPMImage';
import { RPMText } from './subComponents/RPMText';

const FaqShortSlice = ({ data }) => {
    // Destructuring the required fields from data

    console.log("FaqShortSlice data is ", data);

    const {
        colorTheme = 'white',
        headline = '',
        body = '',
        image = null,
        postHeadline = '',
        postDescription = '',
        buttonText = '',
        buttonLink = '',
        items = []
    } = data || {};

    const theme = generateTheme(colorTheme);

    const getHeadline = (headline, idx, col) => {

        if (!headline) return null;

        const isFirstElementInSecondColumnAndIsNotFirstCategoryElement = col > 0 && idx == 0 && headline !== items[0]?.questionHeadline;

        let styling = { display: "block" }

        if (isFirstElementInSecondColumnAndIsNotFirstCategoryElement) {
            styling = { display: { xs: "none", md: "block" } };
        }

        return (
            <RPMText content={headline} variant="h4" component={"h3"} sx={{ margin: "2rem 0 1rem 0rem" }} />

        )
    }

    const generateQuestionItem = (item, idx, col) => {
        {
            return (
                <Grid item xs={12} key={idx}>
                    {getHeadline(item.questionHeadline, idx, col)}
                    <Accordion key={idx} sx={{ margin: '0px', border: '1px solid #E8E2D9', borderRadius: '0.5rem', boxShadow: 'none', backgroundColor: "background.paper" }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel-content"
                            id={`panel-header-${idx}`}
                            style={{ backgroundColor: "background.default" }}

                            sx={{
                                // If you want to set a specific padding, replace 0 with the desired value
                                '& .MuiAccordionSummary-content': {
                                    m: "0 1rem !important", // Override margin for content
                                    p: 0, // Override padding for content
                                },
                                '& .MuiAccordionSummary-contentGutters': {
                                },
                            }}
                        >
                            <RPMText content={item.question} variant='h5' sx={{ margin: "1rem 0" }} />
                        </AccordionSummary>
                        <AccordionDetails>
                            <RPMText content={item.answer} variant='p' sx={{ margin: "0 1rem" }} />
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            )
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, p: 0, background: theme.palette.background.default }}>
                <Stack spacing={0} sx={{ flex: 1, p: { xs: 4, md: 12 }, mb: { xs: 0, md: 0 }, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <RPMText content={headline} variant='h2' />
                    <RPMText content={body} variant='p' />
                    <RPMImage image={image} />

                </Stack>
                <Stack spacing={2} sx={{ flex: 1, p: { xs: 4, md: 12 }, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <Stack sx={{ pt: "0px !important" }}>
                        {items.map((item, idx) => (
                            generateQuestionItem(item, idx, 0)
                        ))}
                    </Stack>

                    <Stack spacing={1} sx={{ justifyContent: 'flex-start', alignItems: 'center', width: "100%" }}>
                        <RPMButton link={buttonLink} linktext={buttonText} type='text' />
                    </Stack>
                </Stack>
            </Box>
        </ThemeProvider>
    );
};

export default FaqShortSlice;